// extracted by mini-css-extract-plugin
export default {"root":"Search_root__3MoGJ","input":"Search_input__WKTI7","icon":"Search_icon__ZOxSo","clearIcon":"Search_clearIcon__OxPAi"};